
	import { Component, Prop, Vue } from 'vue-property-decorator';
	import Loading from '@/components/Loading.vue';

	@Component({
		components: { Loading }
	})
	export default class AgentConnectionError extends Vue {
		@Prop() private msg!: string;

		private reconnect() {
			this.$emit('reconnect');
		}

		private logout() {
			parent.postMessage({ method: 'logout' }, '*');
		}
	}
